import{useActStepperEngine as e}from"../context/ActStepperEngineContext.js";import{Suspense as t}from"react";import{jsx as r}from"react/jsx-runtime";import{styled as n}from"@mui/joy";import o from"@mui/joy/Box";var p=n(o)`
  padding-right: ${({theme:e})=>e.spacing(2)};
  padding-left: ${({theme:e})=>e.spacing(2)};
  overflow: auto;
  flex: 1;
`,i=({steps:n})=>{const o=e(e=>e.currentStep),i=n.find(e=>e.key===o);if(!i)return null;const{component:s,props:m}=i;return r(p,{children:r(t,{children:r(s,{...m??{}})},o)})};export{i as StepperContent};
//# sourceMappingURL=StepperContent.js.map